import EventBus from './Event';
import { preqSaveFields, preqGetFields } from "./api_client/api_prequalification";

class UploadTable {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.$body = this.$el.find('[data-upload-table="body"]');
    this.$template = this.$el.find('[data-upload-row-template]');
    this.$uploadWrap = this.$el.find('[data-upload-table="upload-wrap"]');
    this.$tplClone = this.$template.clone();
    this.$uploadCare = this.$el.find('uc-upload-ctx-provider');

    this.documentGroupsMap = {
      'other_documents': 'Other Documents',
      'photo_id': 'Photo ID',
      'proof_of_income': 'Proof of Income',
      'proof_of_savings': 'Proof of Savings',
    };
    this.documentDbFields = {};
    this.preqFields;

    this.$template.remove();
    this.documents = [];

    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  bindEvents() {
    EventBus.on('user:loaded', this.initTable.bind(this));

    this.$uploadCare.on('file-upload-success', this.onUpload.bind(this));
  }

  async initTable() {
    const user = window.grapp.user;
    if (!user) {
      console.error('No user found');
      return;
    }

    await this.getUserDocuments(user.auth.email);
    this.render();
  }

  async getUserDocuments() {
    const user = window.grapp.user;

    const preq = await preqGetFields(user.auth.email);
    if (preq.success && preq.fields) {
      this.preqFields = preq.fields;
      const { other_documents, photo_id, proof_of_income, proof_of_savings } = preq.fields;
      this.documentDbFields = { other_documents, photo_id, proof_of_income, proof_of_savings };
      Object.keys(this.documentDbFields).forEach(docGroup => {
        if (this.documentDbFields[docGroup]) {
          const docsInGroup = this.documentDbFields[docGroup].split(',');
          docsInGroup.forEach(doc => {
            this.documents.push({ docGroup, docUrl: doc, });
          });
        }
      });
      console.log('this.documents: ', this.documents);
    } else {
      console.log('No documents found');
    }
  }

  async onUpload(e) {
    const originalEvent = e.originalEvent;
    const detail = originalEvent?.detail;
    const cdnUrl = detail?.cdnUrl;

    this.preqFields.other_documents = this.preqFields.other_documents ? `${this.preqFields.other_documents},${cdnUrl}` : cdnUrl;
    const saveReq = await preqSaveFields(this.preqFields);
    if (saveReq.success) {
      this.documents.push({ docGroup: 'other_documents', docUrl: cdnUrl });
      const $row = this.getRowTemplate({ docGroup: 'other_documents', docUrl: cdnUrl, index: this.documents.length });
      this.$body.append($row);
      EventBus.emit('toast', { message: 'File uploaded successfully!', type: 'success' });
    } else {
      EventBus.emit('toast', { message: 'Failed to save document.', type: 'error' });
    }
  }

  render() {
    if (!this.documents || !this.documents.length) {
      const $row = this.getRowTemplate({ ducUrl: '--', upload_row_id: 0 });
      this.$body.append($row);
      return;
    } else {
      // remove 'no documents' row
      this.$body.find('[data-upload-table="document"]').each((i, el) => {
        const $el = $(el);
        if ($el.data('upload-row-id') == 0) {
          $el.remove();
        }
      });
    }

    this.documents.forEach((document, index) => {
      document.index = index + 1;
      const $row = this.getRowTemplate(document);
      this.$body.append($row);
    });
  }

  getRowTemplate(document) {
    const $row = this.$tplClone.clone();
    $row.data('upload-row-id', document.docUrl);
    $row.find('[data-upload-table="document-type"]')
      .text(`${document.index}. ${this.documentGroupsMap[document.docGroup]}`);
    $row.find('[data-upload-table="document-link"]')
      .attr('href', document.docUrl)
      .attr('target', '_blank');

    return $row;
  }

  static init() {
    $('[data-js-component="upload-table"]').each((i, el) => new UploadTable(el));
  }
}

UploadTable.init();
